import * as React from 'react';
import { SVGProps } from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
const WhatsupIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.204 5.762a8.665 8.665 0 0 0-6.167-2.556c-4.807 0-8.718 3.909-8.719 8.714a8.7 8.7 0 0 0 1.163 4.357l-1.237 4.516 4.622-1.212a8.717 8.717 0 0 0 4.167 1.061h.004c4.805 0 8.716-3.91 8.718-8.715a8.662 8.662 0 0 0-2.551-6.165Z"
    />
    <g strokeLinecap="round" strokeLinejoin="round">
      <path d="m13.095 13.56.406-.403c.373-.37.963-.417 1.393-.115.416.292.792.554 1.142.798.556.386.623 1.178.144 1.656l-.359.359M8.145 8.179l.359-.359a1.083 1.083 0 0 1 1.656.144c.243.35.505.726.798 1.142a1.09 1.09 0 0 1-.115 1.393l-.403.406M15.821 15.855c-1.481 1.474-3.97.222-5.935-1.744" />
      <path d="M9.888 14.114C7.923 12.148 6.671 9.66 8.145 8.179M10.44 10.905a8.686 8.686 0 0 0 1.19 1.463l.002.002c.462.462.96.871 1.463 1.19" />
    </g>
  </svg>
);
export default WhatsupIcon;
